// ** React Imports
import { useState, useEffect } from 'react'

// ** MUI Imports
import Grid from '@mui/material/Grid'
import { UserLayoutType, UsersType } from 'src/types/apps/userTypes'

// ** Demo Components Imports
import PlaybookViewRight from './PlaybookViewRight'

import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { Playbook, PlaybookStore, savePlaybook } from './PlaybookStore';
import CustomAvatar from 'src/materio/@core/components/mui/avatar'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import Button from '../../components/froms/UXButton';
import PageHeader from '../../components/froms/UXPageHeader';
import StatisticsBar from '../../components/UXStatisticsBar';
import StatisticsBarItem from '../../components/UXStatisticsBarItem';
import LocalLibrary from '@mui/icons-material/LocalLibrary';


type Props = {
    onClose: () => void
}

const PlaybookView = ({ onClose }: Props) => {
    const [internalPlaybook, setInternalPlaybook] = useState(null as null | Playbook);
    const playbook = PlaybookStore.useState(s => s.selectedPlaybook);
    // ** State
    const [error, setError] = useState<boolean>(false)
    const [data, setData] = useState<null | UsersType>({ avatar: '', fullName: 'Bob Smith' } as UsersType)
    const [openEdit, setOpenEdit] = useState<boolean>(false)

    // Handle Edit dialog
    const handleEditClickOpen = () => setOpenEdit(true)
    const handleEditClose = () => setOpenEdit(false)

    useEffect(() => {
        setInternalPlaybook(playbook);
    }, [openEdit]);

    const onSave = async () => {
        if (internalPlaybook) {
            await savePlaybook(internalPlaybook, '');
        }

        onClose();
    }

    if (data) {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <PageHeader
                        title={playbook?.name ?? ''}
                        subtitle='Update and manage playbook.'
                        buttons={
                            <>
                                <Button title="Edit" variant='contained' sx={{ mr: 3 }} onClick={handleEditClickOpen} icon={<EditIcon />}>
                                    Edit
                                </Button>

                                <Button title="Close" color='secondary' variant='outlined' onClick={onClose} icon={<CloseIcon />}>
                                    Close
                                </Button>
                            </>}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={129} alignItems='right' sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', gap: 1 }}>

                </Grid>

                <StatisticsBar>
                    <StatisticsBarItem title='Messages' icon={<LocalLibraryIcon />} value={playbook?.libraries.length} />
                    <StatisticsBarItem title='Templates Libraries' icon={<ContentCopyIcon />} value={playbook?.templates.length} />
                    <StatisticsBarItem title='Activities' icon={<ShowChartIcon />} value={playbook?.executedCount} />
                    <StatisticsBarItem title="MI' s" icon={<ShowChartIcon />} value={playbook?.miCount} />
                    <StatisticsBarItem title="MQL' s" icon={<ShowChartIcon />} value={playbook?.mqlCount} />
                    <StatisticsBarItem title="DC's" icon={<ShowChartIcon />} value={playbook?.dcCount} />
                    <StatisticsBarItem title='Opportunities' icon={<ShowChartIcon />} value={playbook?.opportunityCount} />         
                </StatisticsBar>                
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <PlaybookViewRight />
                </Grid>

                {
                    internalPlaybook && <Dialog
                        open={openEdit}
                        onClose={handleEditClose}
                        aria-labelledby='user-view-edit'
                        sx={{ '& .MuiPaper-root': { width: '100%', maxWidth: 650, p: [2, 10] } }}
                        aria-describedby='user-view-edit-description'
                    >
                        <DialogTitle id='user-view-edit' sx={{ textAlign: 'center', fontSize: '1.5rem !important' }}>
                            Edit Playbook Details
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText variant='body2' id='user-view-edit-description' sx={{ textAlign: 'center', mb: 7 }}>
                                Playbook name and status.
                            </DialogContentText>
                            <form>
                                <Grid container spacing={6}>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <TextField fullWidth label='Name' defaultValue={internalPlaybook.name} onChange={(e) => setInternalPlaybook({ ...internalPlaybook, name: e.target.value })} />
                                    </Grid>

                                    {/*<Grid item xs={12} sm={12} md={12} lg={12} xl={12} sm={12}>*/}
                                    {/*    <FormControl fullWidth >*/}
                                    {/*        <InputLabel id='user-view-status-label'>Status</InputLabel>*/}
                                    {/*        <Select*/}
                                    {/*            label='Status'*/}
                                    {/*            defaultValue={internalPlaybook.isActive ? "active" : "inactive"}*/}
                                    {/*            id='user-view-status'*/}
                                    {/*            labelId='user-view-status-label'*/}
                                    {/*            onChange={(e) => setInternalPlaybook({ ...internalPlaybook, isActive: e.target.value === "active" })}*/}
                                    {/*        >*/}
                                    {/*            <MenuItem value='active'>Active</MenuItem>*/}
                                    {/*            <MenuItem value='inactive'>Inactive</MenuItem>*/}
                                    {/*        </Select>*/}
                                    {/*    </FormControl>*/}
                                    {/*</Grid>*/}
                                </Grid>
                            </form>
                        </DialogContent>
                        <DialogActions sx={{ justifyContent: 'center' }}>
                            <Button title="Submit" variant='contained' sx={{ mr: 1 }} onClick={onSave} icon={<SaveAltIcon />}>
                                Submit
                            </Button>
                            <Button title="Discard" variant='outlined' color='secondary' onClick={handleEditClose} icon={<CloseIcon />}>
                                Discard
                            </Button>
                        </DialogActions>
                    </Dialog>
                }
            </Grid >
        )
    } else {
        return null
    }
}

export default PlaybookView

